import { useEffect, usePersistedUserData } from 'src/hooks'
import { useValidateUsername } from 'src/react_query'
import { parseError } from 'src/utils/parseError'

const useUsernameValidation = (username: string) => {
  const { isLoading, mutateAsync, error, data, status } = useValidateUsername()
  const { account } = usePersistedUserData()

  useEffect(() => {
    if (username) {
      ;(async () => {
        await mutateAsync({
          username,
        })
      })()
    }
  }, [username, mutateAsync])

  const isUser = account && account.username === 'username'
  return {
    errorMessage: parseError(error, 'Failed to validate username'),
    hasPerformedValidation: status === 'success',
    isLoading,
    isValid: isUser ? true : (data?.valid ?? false),
  }
}

export default useUsernameValidation
